import accessibleAutocomplete from 'accessible-autocomplete'
import IMask from "imask"

class InternetAvailability {
    constructor(form) {
        this.form = form
        this.submitButton = this.form.querySelector('[type="submit"]')
        this.alertBox = this.form.querySelector('[data-alert]')
        this.fields = {}

        this.initAutoComplete()
        this.storeFields()
        this.initOtoIdMask()
        this.bindFieldChange()
        this.bindSubmit()
    }

    initAutoComplete() {

        // replace the existing field with the autocomplete
        const autocompleteField = document.getElementById('customerInstallationStreet')
        const autocompleteContainer = autocompleteField.parentNode
        autocompleteField.remove()


        const suggest = (query, populateResults) => {

            const requestUrl = this.generateRequest(
                '/actions/fibx/address/autocomplete-street-address',
                {
                    streetname: query,
                    city: this.fields.customerInstallationCity.value
                }
            )

            fetch(
                requestUrl,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            ).then(response => {
                return response.json()
            }).then(result => {
                return populateResults(result.data.map(e => e.streetname))
            })
        }

        accessibleAutocomplete({
            element: autocompleteContainer,
            id: 'customerInstallationStreet',
            source: suggest,
            minLength: 2,
            name: 'customerInstallationStreet',
            replace: true,
            required: true,
            // autocomplete: 'address-line1',
            displayMenu: 'overlay',
            tNoResults: () => 'Keine Ergebnisse gefunden'
        })

    }

    storeFields() {
        // store all field for later access/testing
        [...this.getFormData().keys()].map(key => this.fields[key] = document.getElementById(key))
    }

    generateRequest(url, params) {
        const searchParams = new URLSearchParams()
        Object.entries(params).map(([key, value]) => searchParams.append(key, value))

        return `${url}?${searchParams}`
    }

    initOtoIdMask() {
        const mask = IMask(this.fields.customerInstallationOtoid, {
            mask: 'a{.}000{.}000{.}000[{.}0]',
            definitions: {
                'a': /[a-zA-Z]/
            }
        })

        this.fields.customerInstallationOtoid.addEventListener('keyup', e => {
            this.fields.customerInstallationOtoid.value = this.fields.customerInstallationOtoid.value.toUpperCase()
            mask.updateValue()
        })
    }

    getFormData() {
        return new FormData(this.form)
    }

    bindFieldChange() {
        // reset field steet on city change 
        this.fields.customerInstallationCity.addEventListener('change', e => {
            this.fields.customerInstallationStreet.value = ''
            this.fields.customerInstallationStreetNr.value = ''
        }
        )
    }


    bindSubmit() {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault()
            this.submitButton.classList.add('loading')
            this.form.classList.add('loading')
            this.toggleAlertBox(null, true)

            const requestUrl = this.generateRequest(
                '/actions/fibx/availability/check',
                {
                    streetname: this.fields.customerInstallationStreet.value,
                    city: this.fields.customerInstallationCity.value,
                    ...this.splitHouseNumber(this.fields.customerInstallationStreetNr.value),
                    otoid: this.fields.customerInstallationOtoid.value,
                    otoport: 1
                }
            )

            fetch(
                requestUrl,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            ).then(response => {
                return response.json()
            }).then(result => {

                this.toggleAlertBox(result.message, result.success)
                if (result.success == true) {
                    // update hidden field:
                    this.fields.customerInstallationZip.value = result.data.cleanAddress.zip
                    this.fields.responseMessage.value = result.message

                    this.form.dispatchEvent(new Event("availabilityCheckSubmit"))
                    this.form.submit()
                }

            }).finally(() => {
                this.submitButton.classList.remove('loading')
                this.form.classList.remove('loading')
            }).catch(error => {
                console.log(error)
            })

        })

    }


    splitHouseNumber(houseNumber) {

        if (!houseNumber) {
            return {};
        }

        const matches = houseNumber.match(/^(\d+)(\D*)$/);

        if (matches) {
            return {
                house_number: matches[1],
                house_number_suffix: matches[2] || ''
            }
        }
    }

    toggleAlertBox(message, foce = null) {
        this.alertBox.innerText = message
        this.alertBox.classList.toggle('alert--hidden', foce)
    }

}


const internetAvailabilityForm = document.getElementById('internet-availability-form')
new InternetAvailability(internetAvailabilityForm)